import { useRef } from "react";
import { LicenseBar } from "../../../shared/LicenseBar";
import { Header } from "../../../features/Header";
import { TabView, TabPanel } from "primereact/tabview";
import {
  CompanyTabContent,
  ProductTabContent,
  ContactTabContent,
} from "../../../features/tabContent";
import { Toast } from "primereact/toast";
import { ConfirmPopup } from "primereact/confirmpopup";


export const Main = () => {
  const toastRef = useRef(null);

  return (
    <main className="container_local app">
      <Toast ref={toastRef} />
      <ConfirmPopup />
      <Header>
        <LicenseBar toastRef={toastRef} />
      </Header>
      <TabView className="tabView">
        <TabPanel header="Firma">
          <CompanyTabContent toastRef={toastRef} />
        </TabPanel>
        <TabPanel header="Produkt">
          <ProductTabContent toastRef={toastRef} />
        </TabPanel>
        <TabPanel header="Kontakt">
          <ContactTabContent toastRef={toastRef} />
        </TabPanel>
      </TabView>
    </main>
  );
};
